import {
  JOURNEY_MACHINE_EVENT,
  JOURNEY_MACHINE_STATUS,
} from "./journeyConstants";

const stepIds = (steps) => new Set(
  (Array.isArray(steps) ? steps : []).map((step) => step.id),
);

const findStep = (steps, stepId) =>
  (Array.isArray(steps) ? steps : []).find((step) => step.id === stepId) || null;

export const createJourneyMachineState = (stepId = null) => ({
  currentStepId: stepId,
  history: [],
  status: JOURNEY_MACHINE_STATUS.ready,
  error: null,
  revision: 0,
});

export const journeyStateReducer = (state, event) => {
  switch (event.type) {
    case JOURNEY_MACHINE_EVENT.rebase: {
      const validIds = stepIds(event.steps);
      const requested = event.stepId;
      const currentStepId = validIds.has(requested)
        ? requested
        : event.steps?.[0]?.id || null;
      return {
        ...state,
        currentStepId,
        history: state.history.filter((id) => validIds.has(id) && id !== currentStepId),
        revision: state.revision + 1,
      };
    }
    case JOURNEY_MACHINE_EVENT.navigate: {
      if (!findStep(event.steps, event.stepId)) return state;
      const history = event.replaceHistory
        ? state.history
        : [
            ...state.history.filter((id) => id !== state.currentStepId),
            ...(state.currentStepId ? [state.currentStepId] : []),
          ];
      return {
        ...state,
        currentStepId: event.stepId,
        history,
        status: JOURNEY_MACHINE_STATUS.ready,
        error: null,
        revision: state.revision + 1,
      };
    }
    case JOURNEY_MACHINE_EVENT.back: {
      const validIds = stepIds(event.steps);
      const history = state.history.filter((id) => validIds.has(id));
      const current = findStep(event.steps, state.currentStepId);
      const requestedTarget = validIds.has(event.stepId) ? event.stepId : null;
      const target = requestedTarget || current?.backTargetId || state.currentStepId;
      const targetHistoryIndex = history.lastIndexOf(target);
      return {
        ...state,
        currentStepId: target,
        history: targetHistoryIndex >= 0
          ? history.slice(0, targetHistoryIndex)
          : history.filter((id) => id !== target && id !== state.currentStepId),
        status: JOURNEY_MACHINE_STATUS.ready,
        error: null,
        revision: state.revision + 1,
      };
    }
    case JOURNEY_MACHINE_EVENT.fail:
      return {
        ...state,
        status: JOURNEY_MACHINE_STATUS.error,
        error: event.error,
      };
    case JOURNEY_MACHINE_EVENT.retry:
      return {
        ...state,
        status: JOURNEY_MACHINE_STATUS.ready,
        error: null,
        revision: state.revision + 1,
      };
    default:
      return state;
  }
};
